import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useEffect } from 'preact/hooks';
import { useForm } from 'react-hook-form';
import { FormActions } from '@/components';
import { WorkspaceFormFields } from './WorkspaceFormFields';
export function WorkspaceEditForm({ workspace, onChange, onSave, onCancel, loading, isNew }) {
    const { register, control, handleSubmit, watch, setValue, formState: { errors, isValid, isDirty }, reset } = useForm({
        mode: 'onChange',
        defaultValues: {
            Name: workspace.Name || '',
            Description: workspace.Description || '',
            Status: workspace.Status || 'Active',
            TimeZone: workspace.TimeZone || '',
            DailyLeadsSummaryEnabled: workspace.DailyLeadsSummaryEnabled ?? false,
            DailyLeadsSummaryHour: workspace.DailyLeadsSummaryHour ?? 8,
        },
    });
    // Initialize form once; avoid resetting on each external state echo so user edits & errors persist
    useEffect(() => {
        reset({
            Name: workspace.Name || '',
            Description: workspace.Description || '',
            Status: workspace.Status || 'Active',
            TimeZone: workspace.TimeZone || '',
            DailyLeadsSummaryEnabled: workspace.DailyLeadsSummaryEnabled ?? false,
            DailyLeadsSummaryHour: workspace.DailyLeadsSummaryHour ?? 8,
        });
    }, []);
    // Push changes upward so parent keeps draft state (maintain existing API)
    const wName = watch('Name');
    const wDesc = watch('Description');
    const wStatus = watch('Status');
    const wTimeZone = watch('TimeZone');
    const wDailyLeads = watch('DailyLeadsSummaryEnabled');
    const wDailyHour = watch('DailyLeadsSummaryHour');
    useEffect(() => {
        onChange({
            ...workspace,
            Name: wName,
            Description: wDesc,
            Status: wStatus,
            TimeZone: wTimeZone,
            DailyLeadsSummaryEnabled: wDailyLeads,
            DailyLeadsSummaryHour: Number(wDailyHour),
        });
    }, [wName, wDesc, wStatus, wTimeZone, wDailyLeads, wDailyHour]);
    const submit = () => {
        if (!isValid)
            return;
        onSave();
    };
    return (_jsxs("form", { onSubmit: handleSubmit(submit), className: "space-y-4", children: [_jsx("h4", { className: "font-medium text-slate-900 dark:text-slate-100", children: isNew ? 'Add New Workspace' : 'Edit Workspace' }), _jsx(WorkspaceFormFields, { control: control, register: register, errors: errors, watch: watch, setValue: setValue }), _jsx(FormActions, { isSubmitting: loading, isSaveDisabled: !isValid || !isDirty, onCancel: onCancel, saveText: isNew ? 'Add Workspace' : 'Save Changes', className: "px-0 py-1 border-0 bg-transparent dark:bg-transparent" })] }));
}
